/**
 * AI.GEN lines=1-50
 * 国家码到语言的映射配置
 */
import { ICountryCode } from '@/config/country';

/**
 * 语言枚举
 */
export enum LanguageEnum {
  /** 中文 */
  ZhCN = 'zh-CN',
  /** 英文 */
  EnUS = 'en-US',
  /** 法语 */
  FrFR = 'fr-FR',
  /** 日文 */
  JaJP = 'ja-JP',
  /** 韩文 */
  KoKR = 'ko-KR',
}

/**
 * 国家码到语言代码的映射
 */
export const countryToLanguageMap: Record<ICountryCode, LanguageEnum> = {
  CN: LanguageEnum.ZhCN, // 中文
  US: LanguageEnum.EnUS, // 英文
  GB: LanguageEnum.EnUS, // 英文
  NZ: LanguageEnum.EnUS, // 英文
  AU: LanguageEnum.EnUS, // 英文
  CA: LanguageEnum.EnUS, // 英文
  SG: LanguageEnum.EnUS, // 英文
  EUR: LanguageEnum.FrFR, // 法语
  JP: LanguageEnum.JaJP, // 日文
  KR: LanguageEnum.KoKR, // 韩文
};

/**
 * 根据国家码获取语言代码
 */
export const getLanguageByCountry = (
  countryCode: ICountryCode,
): LanguageEnum => {
  return countryToLanguageMap[countryCode] || LanguageEnum.ZhCN;
};

/**
 * 支持的语言列表
 */
export const supportedLanguages = [
  LanguageEnum.ZhCN,
  LanguageEnum.EnUS,
  LanguageEnum.FrFR,
  LanguageEnum.JaJP,
  LanguageEnum.KoKR,
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];
